import React from "react";
import terrain from "../../../../../assets/icons/terrain.png";
import cafeteria from "../../../../../assets/icons/cafeteria.png";
import padel from "../../../../../assets/icons/padel.png";
import boutique from "../../../../../assets/icons/boutique.png";
import "./Services.css";

const SERVICES = [
  {
    icon: terrain,
    alt: "terrain",
    title: "4 Terrains",
    desc: "Plongez dans l'action sur nos 4 terrains de padel dernière génération, prêts à accueillir vos moments de victoire.",
  },
  {
    icon: padel,
    alt: "coach",
    title: "Coaching",
    desc: "Élevez votre jeu avec l'expertise de nos coachs, prêts à guider chaque coup pour votre succès.",
  },
  {
    icon: boutique,
    alt: "boutique",
    title: "Boutique",
    desc: "Explorez notre boutique pour trouver l'équipement parfait, car chaque joueur mérite le meilleur.",
  },
  {
    icon: cafeteria,
    alt: "club house",
    title: "Padel House",
    desc: "Détendez-vous après le match dans notre Club House.",
  },
];

export default function Services() {
  return (
    <div className="services-grid">
      {SERVICES.map((s) => (
        <div key={s.title} className="service-card">
          <img src={s.icon} alt={s.alt} className="service-icon" />
          <div className="service-body">
            <div className="service-title">{s.title}</div>
            <div className="service-desc">{s.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
